<template>
  <tr class="clickable" :class="{disabled: !isActive || isDeleted}"
      @click="goToDetail(item.id)"
  >
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input
          type="checkbox"
          :id="item.id"
          :value="item.id"
          @change="onChange"
          :checked="isChecked"
          @click.stop
      />
      <label :for="item.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Název operátora' | translate" class="first_data"><strong>{{ item.name }}</strong></td>
    <td :data-th="'Počet přiřazených balíčků' | translate">
      <span v-if="item.channel_package_count > 0" class="dotted">{{item.channel_package_count}}
         <ReportsValueDifference columnName="channel_package_count_change" :data="item" />
                <span class="help_popup">
              <ul>
                  <li v-for="(subscriberItem, index) in item.used_channel_packages[subscriberType]" :key="index">
                      {{ subscriberItem.name }}<span>{{ subscriberItem.count }}</span>
                  </li>
              </ul>
          </span>
      </span>
      <span v-else>0
        <ReportsValueDifference columnName="channel_package_count_change" :data="item" />
      </span>
    </td>
    <td :data-th="'Počet odběratelů' | translate">{{ item.subscribers_count }}
      <ReportsValueDifference columnName="subscribers_count_change" :data="item" />
    </td>
    <td :data-th="'Počet fakturovaných odběratelů' | translate">{{ item.paid_device_count }}
      <ReportsValueDifference columnName="paid_device_count_change" :data="item" />
    </td>
    <td :data-th="'Počet firstscreen zařízení nad limit' | translate">{{ item.firstscreen_device_above_limit_count }}
      <ReportsValueDifference columnName="firstscreen_device_above_limit_count_change" :data="item" />
    </td>
    <td class="last_data right no_padding">
      <img v-if="isDeleted" class="state_icon state_icon_wide" src="../../../assets/images/aktivni-neaktivni.svg" alt="Aktivní operátor se stal neaktivním" :title="$gettext('Aktivní operátor se stal neaktivním')"/>
      <img v-if="isNew" class="state_icon" src="../../../assets/images/novy.svg" alt="Nový nebo znovu aktivovaný operátor" :title="$gettext('Nový nebo znovu aktivovaný operátor')" />
      <img v-if="item.active_change === true" class="state_icon state_icon_wide" src="../../../assets/images/neaktivni-aktivni.svg" alt="Neaktivní operátor se stal aktivním" :title="$gettext('Neaktivní operátor se stal aktivním')" />
      <img v-if="item.active_change === false" class="state_icon state_icon_wide" src="../../../assets/images/aktivni-neaktivni.svg" alt="Aktivní operátor se stal neaktivním" :title="$gettext('Aktivní operátor se stal neaktivním')" />
      <img v-if="item.testing_change === true" class="state_icon state_icon_wide" src="../../../assets/images/testovaci-klasicky.svg" alt="Testovací operátor se stal klasickým" :title="$gettext('Testovací operátor se stal klasickým')" />
      <img v-if="item.testing_change === false" class="state_icon state_icon_wide" src="../../../assets/images/klasicky-testovaci.svg" alt="Klasický operátor se stal testovacím" :title="$gettext('Klasický operátor se stal testovacím')" />
      <img v-if="item.testing && item.testing_change === null" class="state_icon" src="../../../assets/images/tester.svg" alt="Testovací operátor" :title="$gettext('Testovací operátor')" />
    </td>
    <td class="no_padding"></td>
  </tr>
</template>

<script>
import ReportsValueDifference from "./ReportsValueDifference";

export default {
  name: "ReportsRow",
  components: {ReportsValueDifference},
  props: {
    item: Object,
    idReport: Number| String,
    selectedItems: Array,
    subscriberType: String,
  },
  computed:{
    isChecked: function () {
      return this.selectedItems.indexOf(String(this.item.id)) > -1
    },
    isDeleted: function (){
      return this.item.changeFlag === "deleted";
    },
    isNew: function (){
      return this.item.changeFlag === "new";
    },
    isActive: function (){
      return this.item.active;
    }
  },
  methods:{
    goToDetail(id_operator) {
      this.$router.push({name: 'reportsOperator', params: {id_operator: id_operator, id_report:this.idReport}})
    },
    onChange: function (e) {
      this.$emit('input', e)
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/reports/ReportsRow.vue